import { render, staticRenderFns } from "./followPopular.vue?vue&type=template&id=5caeee91&scoped=true&"
import script from "./followPopular.vue?vue&type=script&lang=js&"
export * from "./followPopular.vue?vue&type=script&lang=js&"
import style0 from "./followPopular.vue?vue&type=style&index=0&id=5caeee91&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caeee91",
  null
  
)

export default component.exports